import React from "react";

// Renderuje tekst zachowując ręczne łamanie linii: znak nowej linii (\n) → <br />.
// Dzięki temu pola w edytorze są zwykłymi textarea (Enter = łamanie), a nie technicznymi
// polami "linia 1 / linia 2". Łamanie automatyczne dalej wynika z CSS/szerokości.
export function nl(text) {
  const str = String(text == null ? "" : text);
  const parts = str.split("\n");
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br />}
      {part}
    </React.Fragment>
  ));
}
